
module dg.objects {

    export class MatchPerformedLegBulkCommandController {
        public form: any;
        public command: any;
        private lookupResultQuery: any;
        public loadingAutoMatch: boolean = false;

        constructor(
            public $scope: any,
            private restfullApiClientService: dg.restfulApi.RestfullApiClientService,
            private actionService: dg.actions.ActionService
        ) {

        }

        public autoMatch(flightLeg: any, firstMatchIndex: number) {
            if (angular.isDefined(this.lookupResultQuery)) {
                this.loadingAutoMatch = true;
                this.actionService.getQueryResult(this.lookupResultQuery.href).then((lookupData: any) => {
                    const command = this.command;
                    const firstLookupIdex = lookupData.items.findIndex(i => i.id === flightLeg.performedLeg.id);
                    (this.command.flightLegs as Array<any>).forEach((leg, index) => {
                        if(index > firstMatchIndex) {
                            const lookupPerformedLeg = lookupData.items[firstLookupIdex + index - firstMatchIndex];
                            if(lookupPerformedLeg){
                                leg.performedLeg = {
                                    id: lookupPerformedLeg.id,
                                    displayValue: lookupPerformedLeg.displayValue
                                }
                            }
                        }
                    });                    
                }).finally(() => {
                    this.loadingAutoMatch = false;
                });
            }
        }

        $onChanges(changes) {

            if (changes.command.currentValue && changes.command.currentValue.flightLegs) {
                for (let flightLeg of changes.command.currentValue.flightLegs) {
                    flightLeg.dgMeta = this.restfullApiClientService.mergeMetadata(flightLeg.dgMeta);

                    if (flightLeg.dgMeta.properties &&
                        flightLeg.dgMeta.properties.performedLeg &&
                        flightLeg.dgMeta.properties.performedLeg.links &&
                        flightLeg.dgMeta.properties.performedLeg.links.lookupResult &&
                        flightLeg.dgMeta.properties.performedLeg.links.lookupResult.parameters) {
                        if (flightLeg.dgMeta.properties.performedLeg.links.lookupResult.href.endsWith('aircraftId=')) {
                            flightLeg.dgMeta.properties.performedLeg.links.lookupResult.href += flightLeg.aircraft.id;
                        }
                        flightLeg.dgMeta.properties.performedLeg.links.lookupResult.parameters.aircraftId = flightLeg.aircraft.id;
                        this.lookupResultQuery = JSON.parse(JSON.stringify(flightLeg.dgMeta.properties.performedLeg.links.lookupResult));
                    }

                }
            }
        }

    }

    angular.module('fdm.rawFiles').component('matchPerformedLegBulkCommand', {
        bindings: {
            command: '<',
            form: '<'
        },
        controller: MatchPerformedLegBulkCommandController,
        templateUrl: '/app/src/raw-files/match-performed-leg-bulk-command.html'
    });
}